import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { DropzonePhase } from "../core/dropzone.enum.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Typography } from "../../typography/typography.es.js";
const CustomDropzoneMessageContainer = styled("div", styledOptions)(({
  theme,
  color
}) => {
  const selectedColor = color === DropzonePhase.Valid ? theme.palette.success.main : theme.palette.error.main;
  return {
    color: selectedColor,
    display: Displaying.flex,
    padding: `${theme.spacing(2)} 0px`,
    flexDirection: Direction.row,
    justifyContent: Alignment.center,
    alignItems: Alignment.center
  };
});
function DropzoneMessage({
  message,
  color
}) {
  return /* @__PURE__ */ jsx(CustomDropzoneMessageContainer, { className: "dropzone-message", color, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", children: message }) });
}
export {
  DropzoneMessage
};
//# sourceMappingURL=message-container.es.js.map
